import React, { useState } from "react";
// import styles from "./tabs.module.css";

const TabsNoContent = ({ tabs, defaultActiveKey, onSelect }) => {
	const [activeKey, setActiveKey] = useState(defaultActiveKey);

	// Handle tab selection
	const handleTabClick = (eventKey) => {
		setActiveKey(eventKey);
		if (onSelect) onSelect(eventKey);
	};

	return (
		<div className="tabs-container sourceTabs">
			<ul className="tabs" style={{ width: "100%" }}>
				{tabs.map((tab, index) => (
					<li
						key={index}
						className={`tab-item ${
							activeKey === tab.eventKey ? "active" : ""
						}`}
						onClick={() => handleTabClick(tab.eventKey)}>
						<a href={tab.href} className="tab-link">
							{tab.label}
						</a>
					</li>
				))}
			</ul>
		</div>
	);
};

export default TabsNoContent;
